export const iso = {
  code: {
    UNKNOWN: 'Неопределенно',
    'n/a': 'Другие сервисы',
    dj: 'Джибути',
    al: 'Албания',
    gy: 'Гайана',
    af: 'Афганистан',
    dz: 'Алжир',
    as: 'Алжир',
    ad: 'Андорра',
    ao: 'Ангола',
    ai: 'Ангилья',
    ag: 'Антигуа и Барбуда',
    ar: 'Аргентина',
    am: 'Армения',
    aw: 'Аруба',
    au: 'Австралия',
    at: 'Австрия',
    az: 'Азербайджан',
    bs: 'Багамские Острова',
    bh: 'Бахрейн',
    bd: 'Бангладеш',
    bb: 'Барбадос',
    by: 'Белоруссия',
    be: 'Бельгия',
    bz: 'Белиз',
    bj: 'Бенин',
    bm: 'Бермуды',
    bt: 'Бутан',
    bo: 'Боливия',
    ba: 'Босния и Герцеговина',
    bw: 'Ботсвана',
    br: 'Бразилия',
    vg: 'Виргинские Острова (Великобритания)',
    bn: 'Бруней',
    bg: 'Болгария',
    bf: 'Буркина-Фасо',
    bi: 'Бурунди',
    kh: 'Камбоджа',
    cm: 'Камерун',
    ca: 'Канада',
    cv: 'Кабо-Верде',
    ky: 'Острова Кайман',
    cf: 'ЦАР',
    td: 'Чад',
    cl: 'Чили',
    cn: 'Китай',
    co: 'Колумбия',
    km: 'Коморы',
    cd: 'ДР Конго',
    cg: 'Республика Конго',
    ck: 'Острова Кука',
    cr: 'Коста-Рика',
    hr: 'Хорватия',
    cu: 'Куба',
    cw: 'Кюрасао',
    cy: 'Кипр',
    cz: 'Чехия',
    dk: 'Дания',
    dm: 'Доминика',
    do: 'Доминиканская Республика',
    ec: 'Эквадор',
    eg: 'Египет',
    sv: 'Сальвадор',
    gq: 'Экваториальная Гвинея',
    er: 'Эритрея',
    ee: 'Эстония',
    et: 'Эфиопия',
    fk: 'Фолклендские острова',
    fo: 'Фарерские острова',
    fj: 'Фиджи',
    fi: 'Финляндия',
    fr: 'Франция',
    fg: 'Французская Гуана',
    pf: 'Французская Полинезия',
    ga: 'Габон',
    gm: 'Гамбия',
    ge: 'Грузия',
    de: 'Германия',
    gh: 'Гана',
    gi: 'Гибралтар',
    gr: 'Греция',
    gl: 'Гренландия',
    gd: 'Гренада',
    gp: 'Гваделупа',
    gu: 'Гуам',
    gt: 'Гватемала',
    gn: 'Гвинея',
    gw: 'Гвинея-Бисау',
    ht: 'Гаити',
    hn: 'Гондурас',
    hk: 'Гонконг',
    hu: 'Венгрия',
    is: 'Исландия',
    in: 'Индия',
    id: 'Индонезия',
    ir: 'Иран',
    iq: 'Ирак',
    ie: 'Ирландия',
    il: 'Израиль',
    it: 'Италия',
    ci: 'Кот-д’Ивуар',
    jm: 'Ямайка',
    jp: 'Япония',
    jo: 'Иордания',
    kz: 'Казахстан',
    ke: 'Кения',
    ki: 'Кирибати',
    kp: 'КНДР',
    kr: 'Республика Корея',
    kw: 'Кувейт',
    kg: 'Киргизия',
    la: 'Лаос',
    lv: 'Латвия',
    lb: 'Ливан',
    ls: 'Лесото',
    lr: 'Либерия',
    ly: 'Ливия',
    li: 'Лихтенштейн',
    lt: 'Литва',
    lu: 'Люксембург',
    mo: 'Макао',
    mk: 'Северная Македония',
    mg: 'Мадагаскар',
    mw: 'Малави',
    my: 'Малайзия',
    mv: 'Мальдивы',
    ml: 'Мали',
    mt: 'Мальта',
    mq: 'Мартиника',
    mr: 'Мавритания',
    mu: 'Маврикий',
    mx: 'Мексика',
    fm: 'Микронезия',
    md: 'Молдавия',
    mc: 'Монако',
    mn: 'Монголия',
    me: 'Черногория',
    ms: 'Монтсеррат',
    ma: 'Марокко',
    mz: 'Мозамбик',
    mm: 'Мьянма',
    na: 'Намибия',
    np: 'Непал',
    nl: 'Нидерланды',
    an: 'Нидерланды',
    nc: 'Новая Каледония',
    nz: 'Новая Зеландия',
    ni: 'Никарагуа',
    ne: 'Нигер',
    ng: 'Нигерия',
    nu: 'Ниуэ',
    no: 'Норвегия',
    om: 'Оман',
    pk: 'Пакистан',
    pw: 'Палау',
    ps: 'Государство Палестина',
    pa: 'Панама',
    pg: 'Папуа — Новая Гвинея',
    py: 'Парагвай',
    pe: 'Перу',
    ph: 'Филиппины',
    pl: 'Польша',
    pt: 'Португалия',
    pr: 'Пуэрто-Рико',
    qa: 'Катар',
    re: 'Реюньон',
    ro: 'Румыния',
    ru: 'Россия',
    rw: 'Руанда',
    kn: 'Сент-Китс и Невис',
    lc: 'Сент-Люсия',
    ws: 'Самоа',
    sm: 'Сан-Марино',
    st: 'Сан-Томе и Принсипи',
    sa: 'Саудовская Аравия',
    sn: 'Сенегал',
    rs: 'Сербия',
    sc: 'Сейшельские Острова',
    sl: 'Сьерра-Леоне',
    sg: 'Сингапур',
    sk: 'Словакия',
    si: 'Словения',
    sb: 'Соломоновы Острова',
    so: 'Сомали',
    za: 'ЮАР',
    ss: 'Южный Судан',
    es: 'Испания',
    lk: 'Шри-Ланка',
    pm: 'Сен-Пьер и Микелон',
    vc: 'Сент-Винсент и Гренадины',
    sd: 'Судан',
    sr: 'Суринам',
    sz: 'Эсватини',
    se: 'Швеция',
    ch: 'Швейцария',
    sy: 'Сирия',
    tw: 'Тайвань',
    tk: 'Токелау',
    tz: 'Танзания',
    th: 'Таиланд',
    tp: 'Восточный Тимор',
    tg: 'Того',
    to: 'Тонга',
    tt: 'Тринидад и Тобаго',
    tn: 'Тунис',
    tr: 'Турция',
    tm: 'Туркмения',
    tc: 'Теркс и Кайкос',
    tv: 'Тувалу',
    ug: 'Уганда',
    ua: 'Украина',
    ae: 'ОАЭ',
    gb: 'Великобритания',
    us: 'США',
    uy: 'Уругвай',
    uz: 'Узбекистан',
    vu: 'Вануату',
    ve: 'Венесуэла',
    vn: 'Вьетнам',
    ye: 'Йемен',
    zm: 'Замбия',
    zw: 'Зимбабве'
  }
}